import { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import { insertInitialMetaForFrame } from '@comeon/analytics/common';
import { useDispatch } from 'react-redux';
import ProductRedirect from '../../brand/product-redirect.js';

import { WeSpinGameView, WeSpinSessionLobby } from './async.js';
import useTranslations from '../../translation/use-translations';

import { ROUTE_WE_SPIN_GAME_VIEW, ROUTE_WE_SPIN_LOBBY } from './constants/we-spin-route-constants.js';
import useScrollToTop from '../../../hooks/use-scroll-to-top';
import { WE_SPIN_ALL_TEXT_KEYS } from './constants/we-spin-text-keys.js';
import { updateMainContentLoading } from '~/components/brand/ducks/index.js';

import { getRelativePaths } from '~/utils/pathname';
import { ROUTE_WE_SPIN } from '~/components/router/constants.js';

const WeSpinSessionLobbyProduct = () => (
	<ProductRedirect product="we-spin">
		<WeSpinSessionLobby />
	</ProductRedirect>
);

const CHILD_ROUTES = [ROUTE_WE_SPIN_LOBBY, ROUTE_WE_SPIN_GAME_VIEW];

const WeSpinRoutes = () => {
	const dispatch = useDispatch();
	const paths = useMemo(() => getRelativePaths(CHILD_ROUTES, ROUTE_WE_SPIN), []);

	const { translations, isLoadingTranslations } = useTranslations(WE_SPIN_ALL_TEXT_KEYS);
	useEffect(() => {
		insertInitialMetaForFrame('we-spin', dispatch);
		dispatch(updateMainContentLoading('loaded'));
	}, [dispatch]);

	useScrollToTop();

	return (
		!isLoadingTranslations && (
			<>
				<Helmet>
					<meta name="keywords" content={translations.META_KEYWORDS_WE_SPIN} />
					<meta name="description" content={translations.META_DESCRIPTION_WE_SPIN} />
					<title>{translations.WE_SPIN_SITE_TITLE}</title>
				</Helmet>
				<TracedRoutes>
					<Route
						key="we-spin-explore"
						path={paths[ROUTE_WE_SPIN_LOBBY]}
						element={<WeSpinSessionLobbyProduct />}
					/>
					<Route
						exact
						key="we-spin-game-view"
						path={`${paths[ROUTE_WE_SPIN_GAME_VIEW]}/:streamRef`}
						element={<WeSpinGameView />}
					/>
				</TracedRoutes>
			</>
		)
	);
};

export default WeSpinRoutes;
